<template>
	<div id="calendar" class="clearfix gibson px2 mb4">
		<div class="col-12">
      <div v-if="loading">
        <Loading></Loading>
      </div>
      <div class="clearfix" v-else>
          <div class="col-12 mt2 px0 flex justify-between items-center">
              <p class="h1 regular line-height-2 my3">Kalendar</p>
          </div>
          <div class="col-12 p0">
              <FullCalendar
              ref="fullCalendar"
              default-view="dayGridMonth"
              :header="{ left: 'prev',center: 'title',right: 'next' }"
              :editable="false"
              :droppable="false"
              :plugins="calendarPlugins"
              :events="calendarEventsData.events"
              :weekends="calendarWeekends"
              :theme-system="themeSystem"
              :event-time-format="calendarEventsData.eventTimeFormat"
              :locale = "locale"
              @dateClick="dateClicked($event)"
              @eventClick="eventClick($event)"
            />
          </div>
      </div>
		</div>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
	</div>
</template>

<script>
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import listPlugin from '@fullcalendar/list'
const FullCalendar = () => import('@fullcalendar/vue')
const allLocales = () => import('@fullcalendar/core/locales-all')
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')

/* eslint-disable no-unused-vars */
export default {
  components: {
    FullCalendar,
    Loading,
    ErrorHandler
  },
  created () {
    this.displayCurrentProject()
  },
  data () {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      calendarWeekends: true,
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        bootstrapPlugin,
        listPlugin
      ],
      locales: allLocales,
      locale: 'da-dk',
      themeSystem: 'bootstrap',
      calendarEventsData: {
        events: [],
        validRange: {
          start: new Date()
        },
        visibleRange: {
          start: new Date(2018, 8, 1),
          end: new Date(5018, 8, 1)
        },
        eventTimeFormat: { // like '14:30:00'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false,
          hour12: false
        }
      },
      selectedAddress: 'all'
    }
  },
  methods: {
    displayCurrentProject () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(process.env.BITRIXAPI + 'partner/projects', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.data && res.data.length > 0) {
            res.data.forEach((prop, index) => {
              if (prop.IS_ACTIVE === 1) {
                this.currentProjectData = prop
              }
            })
          }
          this.displayEvents()
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    displayEvents () {
      this.calendarEventsData.events = []
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      var url = null
      var projectId = null
      var addressId = null

      if (this.selectedAddress !== 'all') {
        projectId = this.selectedAddress.split('-')[1]
        addressId = this.selectedAddress.split('-')[0]
      } else {
        projectId = this.currentProjectData.ID
        addressId = this.currentProjectData.ADDRESS.ID
      }

      if (this.$route.query.fromProject) {
        url = process.env.BITRIXAPI + 'partner/calendars?projectId=' + projectId + '&addressId=' + addressId
        this.selectedAddress = addressId + '-' + projectId
      } else {
        if (this.selectedAddress !== 'all') {
          url = process.env.BITRIXAPI + 'partner/calendars?projectId=' + projectId + '&addressId=' + addressId
        } else {
          url = process.env.BITRIXAPI + 'partner/calendars'
        }
      }
      this.$http.get(url, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.data) {
            this.activitiesData = res.data
            // Sort upcoming events
            this.activitiesData.sort(function (a, b) {
              var dateA = new Date(a.DATE)
              var dateB = new Date(b.DATE)
              return dateA - dateB
            })
            var dateTime = ''
            var date = ''
            var dateYear = ''
            var dateMonth = ''
            var dateDay = ''
            var id = ''
            var title = ''
            var start = ''
            var startHour = ''
            var startMin = ''
            var startSec = ''
            var end = ''
            var endHour = ''
            var endMin = ''
            var endSec = ''
            var color = ''
            var description = ''
            var type = ''
            for (var i = 0; i < res.data.length; i++) {
              dateTime = res.data[i].DATE.split(' ')
              date = dateTime[0].split('-')
              dateYear = parseInt(date[0])
              dateMonth = parseInt(date[1]) - 1
              dateDay = parseInt(date[2])
              id = res.data[i].ID
              title = res.data[i].TITLE
              start = res.data[i].START_TIME.split(':')
              startHour = parseInt(start[0])
              startMin = parseInt(start[1])
              startSec = parseInt(start[2])
              end = res.data[i].END_TIME.split(':')
              endHour = parseInt(end[0])
              endMin = parseInt(end[1])
              endSec = parseInt(end[2])
              color = '#' + res.data[i].COLOR
              description = res.data[i].DESCRIPTION
              type = res.data[i].TYPE
              this.calendarEventsData.events.push(
                {
                  id: id,
                  title: title,
                  start: new Date(dateYear, dateMonth, dateDay, startHour, startMin, startSec),
                  end: new Date(dateYear, dateMonth, dateDay, endHour, endMin, endSec),
                  description: description,
                  type: type,
                  backgroundColor: color
                })
            }
          }
          // this.getContacts()
          this.loading = false
          if (this.$route.query.showInfo) {
            // this.eventClick(null)
          }
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    }
  }
}
</script>
<style lang="scss">

@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/bootstrap/main.css";
@import "~@fullcalendar/list/main.css";

  #calendar .fc-scroller {
    overflow: hidden !important;
  }
  #calendar div .table-bordered thead th, div .table-bordered thead td, div .table-bordered, div .fc th, div .fc td {
    border: none;
  }
  #calendar div .fc-toolbar h2 {
    text-transform: capitalize; 
  }
  #calendar div .table-bordered thead th {
    font-weight: 400;
  }
  #calendar div .fc-row .fc-content-skeleton, div .fc-row .fc-content-skeleton table, div .fc-row .fc-content-skeleton table thead {
    height: 100%;
  }
  #calendar div .fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {
    display: flex;
    justify-content: center;
    padding-top: 2rem;
    font-size: 18px;
    float: none !important;
  }

  #calendar .fc-toolbar.fc-header-toolbar button .fa-chevron-left:before {
    content: "\e6ea";
    font-family: element-icons;
  }

  #calendar .fc-toolbar.fc-header-toolbar button .fa-chevron-right:before {
    content: "\e6e9";
    font-family: element-icons;
  }

  #calendar .fc-toolbar.fc-header-toolbar button {
    border-color: #000;
    border-radius: 50%;
    background-color: transparent;
    color: #000;
  }
  #calendar .fc-toolbar.fc-header-toolbar button:focus {
    box-shadow: none;
  }
  #calendar .fc td.fc-today {
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: center;
  } 
  #calendar div .fc-ltr .fc-dayGrid-view td.fc-today .fc-day-number {
    background-color: #003645;
    color: #fff;
    border: 1px solid;
    border-radius: 50%;
    display: inline-block;
    padding: 5%;
    text-align: center;
  }
  #calendar div .fc-day-grid-event .fc-content span {
    display: block;
    text-align: center;
  }
  #calendar div .fc-day-grid-event {
    cursor: pointer;
    padding: 5px;
    margin: 5px 7px;
    border: 0
  }
  #calendar div .fc-day-grid-event::after {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// calendar.vue?4661acc6